/*
    Exp Product Template - Custom pricing logic with base_pack_total_cents strikethrough
*/

// Listen for variant changes and update pricing with strikethrough
window.addEventListener('variantChange.ecomify.product', (event) => {
    // Only run for exp-template
    const expTemplate = document.querySelector('[data-exp-template="true"]')
    if (!expTemplate) return

    const selectedVariant = event.detail
    const productContent = expTemplate.querySelector('.product-content')
    const priceElement = productContent.querySelector('.product-price')
    if (!priceElement) return

    // Check if subscription is selected
    const subscriptionSelected = !!document.querySelector('#purchase-options-subscription:checked, #purchase-options-subscription-treatment:checked')

    // Calculate strikethrough price and final price
    let basePackTotalCents = null
    let currentPrice = selectedVariant.price

    if (subscriptionSelected && selectedVariant.selling_plan_allocations && selectedVariant.selling_plan_allocations[0]) {
        // Subscription selected: show regular price as strikethrough, subscription price as final
        basePackTotalCents = selectedVariant.price
        currentPrice = selectedVariant.selling_plan_allocations[0].price
    } else if (selectedVariant.title.includes('Pack')) {
        // Pack size discount logic (for one-time purchase)
        // Find minimum pack size as base
        let basePackSize = null
        let baseBarPrice = null

        window.productVariants.forEach(v => {
            const packSize = parseInt(v.title.replace(' Pack', ''))
            if (packSize > 0 && (basePackSize === null || packSize < basePackSize)) {
                basePackSize = packSize
                baseBarPrice = Math.floor(v.price / packSize)
            }
        })

        if (basePackSize && baseBarPrice) {
            const currentPackSize = parseInt(selectedVariant.title.replace(' Pack', ''))

            if (currentPackSize > basePackSize) {
                basePackTotalCents = baseBarPrice * currentPackSize
                // Only show if there's actual savings
                if (basePackTotalCents <= selectedVariant.price) {
                    basePackTotalCents = null
                }
            }
        }
    }

    // Build price HTML with strikethrough if applicable
    let priceHTML = ''

    if (basePackTotalCents) {
        priceHTML = `
            <span class="product-price-compare text-muted me-3">
                <span class="visually-hidden">
                    Regular price: &nbsp;
                </span>
                <s>
                    ${Shopify.formatMoney(basePackTotalCents)}
                </s>
            </span>
            <span class="product-price-final">
                ${Shopify.formatMoney(currentPrice)}
            </span>
            <span class="product-item-price-pack opacity-50 fs-6 ms-2">
                /${selectedVariant.title}
            </span>
        `
    } else {
        priceHTML = `
            <span class="product-price-final">
                ${Shopify.formatMoney(currentPrice)}
            </span>
            <span class="product-item-price-pack opacity-50 fs-6 ms-2" ${selectedVariant.title.includes('Pack') ? '' : 'hidden'}>
                /${selectedVariant.title}
            </span>
        `
    }

    priceElement.innerHTML = priceHTML
})
